import React from 'react'
import styled, { DefaultTheme } from 'styled-components'
import {
  DepositAccountName,
  InvestAccountName,
  CCAccountName,
} from '@ally/data-types-customization'
import { Box } from '@ally/metronome-ui'
import { reorderListItemLabel } from '../../constants'
import { AccountTypesObj, KeyValPair } from '../../types'

const StyledItem = styled(Box)<{
  type: keyof DefaultTheme['colors']
}>`
  ${({ type, theme: { colors, space } }): string => `
    display: flex;
    align-items: center;
    padding-left: ${space.sm};
    border-left: 10px solid ${colors[type]};
  `}
`

function accountType(name: string): keyof DefaultTheme['colors'] {
  switch (name) {
    case DepositAccountName.SAVINGS:
      return 'sda'
    case DepositAccountName.CD:
      return 'cda'
    case DepositAccountName.IRA:
      return 'ira'
    case InvestAccountName.INVS:
      return 'inv'
    case InvestAccountName.INVA:
      return 'inva'
    case InvestAccountName.INVW:
      return 'invw'
    case CCAccountName.PLATINUM:
      return 'blue-900'
    case CCAccountName.EVERYDAY:
      return 'blue-300'
    case CCAccountName.UNLIMITED:
      return 'blue-700'
    default:
      return 'dda'
  }
}

const AccountTypeItem: React.FC<{ item: AccountTypesObj }> = ({ item }) => {
  const { name } = item
  return (
    <StyledItem type={accountType(name)} fontWeight="bold">
      {reorderListItemLabel[name as keyof KeyValPair]}
    </StyledItem>
  )
}

export default AccountTypeItem
